import { cn } from '@/lib/utils';
import React from 'react';
interface BottomFixedContainerProps {
  children: React.ReactNode;
  className?: string;
}
function BottomFixedContainer({
  children,
  className
}: BottomFixedContainerProps) {
  return <div className={cn(`fixed bottom-0 left-0 z-50 max-h-fit w-full bg-white p-5 md:static md:p-0 `, className)} data-sentry-component="BottomFixedContainer" data-sentry-source-file="bottom-fixed-container.tsx">
      {children}
    </div>;
}
;
export default BottomFixedContainer;